import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@utilities';

import { parseNumber } from '../../utilities/helpers';

import styles from './_index.module.scss';

const VolumeInputs = ({ onChangeValues, selectedAnswer }) => {
  const [heavy, setHeavy] = useState(selectedAnswer?.values?.[1] ?? '');
  const [light, setLight] = useState(selectedAnswer?.values?.[0] ?? '');

  useEffect(() => {
    setHeavy(selectedAnswer?.values?.[1] ?? '');
    setLight(selectedAnswer?.values?.[0] ?? '');
  }, [selectedAnswer?.attributeId]);

  const validInput = useMemo(() => {
    if (!heavy || !light) {
      return true;
    }
    const lightValue = parseNumber(light);
    const heavyValue = parseNumber(heavy);
    return lightValue < heavyValue;
  }, [light, heavy]);

  const handleChange = (nextLight, nextHeavy) => {
    onChangeValues([parseNumber(nextLight), parseNumber(nextHeavy)]);
  };

  return (
    <div className={styles['volume-inputs-config-block']}>
      <div>
        <h4>HEAVY</h4>
        <div className={styles['volume-inputs-config-block-input']}>
          <p>Greater than the value of</p>
          <Input
            onChange={(val) => {
              setHeavy(val);
              handleChange(light, val);
            }}
            placeholder="--"
            type="number"
            value={heavy}
          />
        </div>
      </div>

      <div>
        <h4>LIGHT</h4>
        <div className={styles['volume-inputs-config-block-input']}>
          <p>Less than the value of</p>
          <Input
            onChange={(val) => {
              setLight(val);
              handleChange(val, heavy);
            }}
            placeholder="--"
            type="number"
            value={light}
          />
        </div>
      </div>

      <div className={styles['volume-inputs-config-block-helper']}>
        <span>* Medium buyers will be automatically calculated.</span>
      </div>

      {!validInput && (
        <div className={styles['volume-inputs-error-message']}>
          <span>* Heavy must be greater than light</span>
        </div>
      )}
    </div>
  );
};

VolumeInputs.propTypes = {
  onChangeValues: PropTypes.func.isRequired,
  selectedAnswer: PropTypes.shape({
    attributeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }).isRequired,
};

export default VolumeInputs;
